<template>
<div v-show='isFixedBg'
     class='b-fixed-background'
     @click='hideFixedBg'>
</div>
</template>

<script lang='ts'>
import { Component, Vue, Watch } from 'vue-facing-decorator';
import { useCommonStore } from '@/stores/useCommonStore';

@Component
export default class FixedBackground extends Vue {
    commonStore = useCommonStore();

    get isFixedBg() {
        return this.commonStore.isFixedBg;
    }

    hideFixedBg() {
        this.commonStore.setFixedBgStatus(false);
        this.commonStore.setHideBgStatus(false);
    }

    @Watch('$route')
    watchHandler() {
        if (this.isFixedBg) {
            setTimeout(() => {
                this.commonStore?.setFixedBgStatus(false);
            }, 0);
        }
    }
}
</script>

<style lang='sass'>
.b-fixed-background
    z-index: 10
    position: fixed
    left: 0
    top: 0
    right: 0
    bottom: 0
    width: 100%
    height: 100%
    background-color: $fixed-bg-color

.b-over-fixed-background
    z-index: 11
</style>
